import React, { FunctionComponent, useRef } from "react";
import { Linking, Modal, Pressable, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FontAwesome5, MaterialIcons } from "@expo/vector-icons";
import { Button as Button2, ButtonIcon, HStack, VStack } from "@gluestack-ui/themed";

import { getIconItem, getIconItemPTW } from "../utils/itemCommonFunctions";
import { customApp } from "../config";
import { calcularVelocidadConexion } from "../utils/general";
import Spacer from "./base/Spacer";

export interface ModalIconInfoProps {
    showIconInfo: boolean;
    setShowIconInfo: (show: boolean) => void;
    statusStore: any;
    isPTW?: boolean;
}

export const ModalIconInfo: FunctionComponent<ModalIconInfoProps> = ({
    showIconInfo,
    setShowIconInfo,
    statusStore,
    isPTW = false,
}) => {
    const setSpeedTest = (speed: string) => {
        statusStore.setFlashMessage("Velocidad de Conexion ".concat(speed, "Mbps"));
    };

    const SpeedTestComponent = () => {
        return (
            <View style={styles.speedTestHeader}>
                <Text style={styles.headerText}>Probar velocidad de conexión</Text>
                <Spacer />
                <Button2 width={50} height={50} p="$1" variant="link" onPress={() => calcularVelocidadConexion(setSpeedTest, statusStore)}>
                    <ButtonIcon as={MaterialIcons} name="speed" fontWeight="$extrabold" size="xl" color="$red500" />
                </Button2>
            </View>
        )
    }

    const WorkflowIconInfo = () => {
        return (<><HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("draft")}
                    <Text style={styles.itemTextWithMargin}>Registro nuevo para ser completado. {isPTW ? "true" : "false"}</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("draft")}
                    {getIconItemPTW("pending")}
                    <Text style={[styles.itemText, { width: "80%" }]}>Registro creado por otro usuario y que debo completar</Text>
                </HStack>
                {isPTW != true ? <></> : (
                    <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                        {getIconItem("draft")}
                        {getIconItemPTW("finished")}
                        <Text style={styles.itemText}>Registro aprobado, debo cerrar trabajo</Text>
                    </HStack>
                )}

                {!isPTW ? <></> : (
                    <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                        {getIconItem("draft")}
                        {getIconItemPTW("closing")}
                        <Text style={styles.itemText}>Registro en cierre, debo cerrar mi control</Text>
                    </HStack>
                )}

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("closed")}
                    <Text style={[styles.itemTextWithMargin, { width: "90%" }]}>Registro completado listo para subirse al servidor.</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("closed")}
                    {getIconItemPTW("pending")}
                    <Text style={[styles.itemText, { width: "90%" }]}>Registro creado por otro usuario, que ya complete y debo subir al servidor</Text>
                </HStack>

                {!isPTW? <></>:  (
                    <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                        {getIconItem("closed")}
                        {getIconItemPTW("closing")}
                        <Text style={styles.itemText}>Registro en cierre, debo subir mi control</Text>
                    </HStack>
                )}

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("inprogress")}
                    <Text style={[styles.itemText, { width: "90%" }]}>Registro en el que ya participe, y que continua su workflow</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("waiting")}
                    <Text style={[styles.itemText, { width: "80%" }]}>Registro en el que debo participar, pero esta en una etapa previa</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("finished")}
                    <Text style={[styles.itemText, { width: "90%" }]}>Registro con aprobación completa, pendiente fin de trabajo</Text>
                </HStack>

                {isPTW && (
                    <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                        {getIconItem("sent")}
                        {getIconItemPTW("closing")}
                        <Text style={styles.itemText}>Registro en proceso de Cierre</Text>
                    </HStack>
                )}

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("closed")}
                    <Text style={styles.itemText}>{isPTW ? "Registro cerrado" : "Registro cerrado"}</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("reject")}
                    <Text style={styles.itemText}>Solicitud rechazada</Text>
                </HStack>

                <HStack borderBottomWidth={1} borderBottomColor="#CBD5E1" py={4} alignItems="center">
                    {getIconItem("sent")}
                    {getIconItemPTW("error")}
                    <Text style={styles.itemText}>Error en la definición del comportamiento del Flujo de trabajo</Text>
                </HStack>

                <View style={styles.sectionHeader}>
                    <Text style={styles.headerText}>VISIBILIDAD</Text>
                </View>
                <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }}>
                    <Text style={styles.itemText}>
                        Los registros cerrados o rechazados permanecerán visibles durante las 24 horas posteriores a su gestión.
                        Pasado ese tiempo, deberán consultarse desde el módulo de gestión administrativa.
                    </Text>
                </View></>)
    }

    const Info = () => {
        return (
            <VStack>
                {SpeedTestComponent()}
                {customApp.isMeasurement ? <></> : WorkflowIconInfo()}
                {customApp.packagename !== "com.voolks.cgc" ? <></>: (
                    <>
                        <View style={styles.sectionHeader}>
                            <Text style={styles.headerText}>INSTRUCTIVOS</Text>
                        </View>
                        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/cgcpdt/CGC-PDT-Intro.mp4")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Instructivo Introductorio</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/cgcpdt/CGC-PDT-CasoPractico.mp4")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Instructivo Caso Práctico</Text>
                            </TouchableOpacity>
                        </View>
                    </>
                )}
                {customApp.packagename !== "com.voolks.pampaptw" ? <></> : (
                    <>
                        <View style={styles.sectionHeader}>
                            <Text style={styles.headerText}>INSTRUCTIVOS</Text>
                        </View>
                        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/1IqRKrADc9SsXKRSVxVsDCV0q6LTxRItQ/view?usp=drive_link")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Documentación </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/1RSbKyjnx3WyJUqhKuWGv_wDR82fcZvmy/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A1 </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/19HqCPAnnEqwwc-p6tJ85imapRl-maxNv/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A1 Cadena de aprobación </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A1 - Habilitante </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A1 - Cierre del Trabajo </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/14PTl4X_6SeYY35q8z9eNX94D02IYwxCN/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A2 </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/1IZV7c2Mg0l_TtuKfciHpGaScE35XDiHa/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A3 </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRowHalf}
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/1tNYLKltjtscGLj2eehmb4IVqmjzQA_zF/view?usp=drive_link")}
                            >
                                <MaterialIcons name="video-library" size={20} color="#c084fc" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Anexo A4 </Text>
                            </TouchableOpacity>
                        </View>
                    </>
                )}
                {customApp.packagename !== "com.voolks.pampacertificacion" ? <></>: (
                    <>
                        <View style={styles.sectionHeader}>
                            <Text style={styles.headerText}>INSTRUCTIVOS</Text>
                        </View>
                        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/pampaenergia/certificacion/Ariba+Network+-+Agregar+Usuarios.pdf")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Ariba Network - Agregar Usuarios.pdf</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/pampaenergia/certificacion/Ariba+Network+-+Capacitacio%CC%81n+PAMPA+ENERGIA.pdf")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Ariba Network - Capacitación</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/pampaenergia/certificacion/Pampa+Carga+de+PM+y+DM+Ver.+2.mp4")}
                            >
                                <FontAwesome5 name="file-video" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Carga de PM y DM</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/pampaenergia/certificacion/Portal+cobranzas+-+Solicitud+de+OP+y+retenciones+7.pdf")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Portal cobranzas - Solicitud de OP y retenciones</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.linkRow}
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/pampaenergia/certificacion/Instructivo+Certificacion+Digital+-+Proveedor+V1.pdf")}
                            >
                                <FontAwesome5 name="file-pdf" size={20} color="#38bdf8" style={{ marginRight: 8 }} />
                                <Text style={styles.itemText}>Instructivo Certificacion Digital - Proveedor</Text>
                            </TouchableOpacity>
                        </View>
                    </>
                )}
            </VStack>
        );
    };

    if (!showIconInfo) return <></>;

    return (
        <Modal transparent animationType="fade" visible={showIconInfo} onRequestClose={() => setShowIconInfo(false)}>
            <View style={styles.modalOverlay}>
                <View style={styles.modalContent}>
                    <View style={styles.modalHeader}>
                        <Text style={styles.modalTitle}>Descripción iconos</Text>
                        <Pressable onPress={() => setShowIconInfo(false)} hitSlop={10}>
                            <MaterialIcons name="close" size={22} color="#666" />
                        </Pressable>
                    </View>
                    <ScrollView style={styles.modalBody}>
                        <Info />
                    </ScrollView>
                </View>
            </View>
        </Modal>
    );
};

export interface ModalInfoProps {
    alertDialog: { title: string; message: string; action: Function } | undefined;
    setAlertDialog: (dialog: any) => void;
}

export const ModalInfo: FunctionComponent<ModalInfoProps> = ({ alertDialog, setAlertDialog }) => {
    if (alertDialog === undefined) return <></>;

    return (
        <Modal transparent animationType="fade" visible={alertDialog !== undefined} onRequestClose={() => setAlertDialog(undefined)}>
            <View style={styles.modalOverlay}>
                <View style={styles.alertContent}>
                    <View style={styles.modalHeader}>
                        <Text style={styles.modalTitle}>{alertDialog?.title}</Text>
                        <Pressable onPress={() => setAlertDialog(undefined)} hitSlop={10}>
                            <MaterialIcons name="close" size={20} color="#666" />
                        </Pressable>
                    </View>
                    <View style={styles.modalBody}>
                        <Text style={styles.itemText}>{alertDialog?.message}</Text>
                    </View>
                    <View style={styles.modalFooter}>
                        <TouchableOpacity style={[styles.btn, styles.btnCancel]} onPress={() => setAlertDialog(undefined)}>
                            <Text style={styles.btnCancelText}>Cancelar</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                            style={[styles.btn, styles.btnConfirm]}
                            onPress={() => {
                                alertDialog?.action();
                                setAlertDialog(undefined);
                            }}
                        >
                            <Text style={styles.btnConfirmText}>Aceptar</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
    },
    modalContent: {
        backgroundColor: "#fff",
        borderRadius: 8,
        width: "95%",
        maxHeight: "85%",
        elevation: 5,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
    },
    alertContent: {
        backgroundColor: "#fff",
        borderRadius: 8,
        width: "85%",
        maxWidth: 400,
        elevation: 5,
    },
    modalHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: "#E2E8F0",
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#1E293B",
    },
    modalBody: {
        padding: 16,
    },
    modalFooter: {
        flexDirection: "row",
        justifyContent: "flex-end",
        padding: 16,
        borderTopWidth: 1,
        borderTopColor: "#E2E8F0",
    },
    speedTestHeader: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        backgroundColor: "#226073",
        paddingHorizontal: 10,
        borderRadius: 4,
    },
    sectionHeader: {
        flexDirection: "row",
        flexWrap: "wrap",
        backgroundColor: "#000",
        padding: 10,
        marginTop: 10,
        borderRadius: 4,
    },
    headerText: {
        color: "#fff",
        fontWeight: "bold",
        alignSelf: "center",
    },
    itemText: {
        color: "#1E293B",
        fontSize: 14,
    },
    itemTextWithMargin: {
        color: "#1E293B",
        fontSize: 14,
        marginLeft: 24,
    },
    linkRow: {
        flexDirection: "row",
        alignItems: "center",
        padding: 10,
        minWidth: "50%",
    },
    linkRowHalf: {
        flexDirection: "row",
        alignItems: "center",
        padding: 10,
        minWidth: "50%",
    },
    btn: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        borderRadius: 4,
        marginLeft: 8,
    },
    btnCancel: {
        backgroundColor: "#E2E8F0",
    },
    btnCancelText: {
        color: "#475569",
        fontWeight: "600",
    },
    btnConfirm: {
        backgroundColor: "#EF4444",
    },
    btnConfirmText: {
        color: "#FFFFFF",
        fontWeight: "600",
    },
});